import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { OrAvatarComponent, PageLayoutComponent, TitileNavbarComponent } from '@ui-components';
import { LocalRefreshService, MODAL_TOKEN, ModalProvider } from '@core';
import { switchMap, tap } from 'rxjs';
import {
  GetTeamDetailsQueryHandler,
  GetTeamDetailsQueryResult,
  UpdateTeamMemberCommandHandler
} from '../../application/handlers';
import { ActivatedRoute, Params } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'lib-switch-auto-approve',
  templateUrl: './switch-auto-approve.component.html',
  styleUrls: ['./switch-auto-approve.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, OrAvatarComponent, TitileNavbarComponent, PageLayoutComponent],
  providers: [GetTeamDetailsQueryHandler, LocalRefreshService, UpdateTeamMemberCommandHandler]
})
export class SwitchAutoApproveComponent {
  private readonly getTeamDetailsQueryHandler: GetTeamDetailsQueryHandler = inject(GetTeamDetailsQueryHandler);
  private readonly localRefreshService: LocalRefreshService = inject(LocalRefreshService);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private readonly updateTeamMemberCommandHandler: UpdateTeamMemberCommandHandler =
    inject(UpdateTeamMemberCommandHandler);
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);

  readonly teamDetails: Signal<GetTeamDetailsQueryResult | undefined> = toSignal(
    this.localRefreshService.refresh$.pipe(
      switchMap(() => this.modalProvider.showLoading$()),
      switchMap(() => this.activatedRoute.params),
      switchMap((params: Params) => this.getTeamDetailsQueryHandler.teamDetails(params['id'])),
      tap(() => this.modalProvider.dismissLoading())
    )
  );

  switchAutoApproved(isAutoApproved: boolean, userId: string, teamId: string): void {
    this.updateTeamMemberCommandHandler
      .update(teamId, userId, !isAutoApproved)
      .subscribe(() => this.localRefreshService.emit());
  }
}
